import RankingInfoAndBtn from './RankingInfoAndBtn';

export default RankingInfoAndBtn;
